import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["form", "mirror"]

  submit() {
    this.mirrorTargets.forEach(function(hidden) {
      let source = document.getElementById(hidden.dataset.sourceId)
      if (source) hidden.value = source.value
    })
    this.formTarget.submit()
  }
}
